import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core'
import {Store} from '@ngrx/store'
import {ErrorsProps, logErrorToBackand, toErrorsPage} from '../store/errors/errors.actions'
import {BladSamoobslugi} from './types/blad-samoobslugi'
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler{

  private prevError: Error | undefined = undefined;
  constructor(private injector: Injector, private zone: NgZone) { }

  handleError(error: Error): void {
    if (JSON.stringify(error) === JSON.stringify(this.prevError)) {
      this.prevError = undefined
      return
    }

    const blad: ErrorsProps = this.utworzBlad(error)
    const store = this.injector.get(Store)
    this.prevError = error

    this.zone.run( () => {
      store.dispatch(toErrorsPage(blad))
      store.dispatch(logErrorToBackand({error}))
    })

  }

  private utworzBlad(error: Error): ErrorsProps {
    let message: string
    console.log('Error:', error)
    if (error instanceof BladSamoobslugi || !environment.production) {
      message = error.message
    } else {
      message = 'Przepraszamy, coś poszło nie tak. Spróbuj ponownie później.'
    }
    return {payload: {
        errors: {message}
    }}
  }
}
